import {LinkProp} from '../../../../types';

export enum HeaderColumns {
  MAIN_BAR = 'Main (top, always visible)',
  FIRST_COLUMN = '1st column',
  SECOND_COLUMN = '2nd column',
  THIRD_COLUMN = '3rd column',
  FOURTH_COLUMN = '4th column',
  FIFTH_COLUMN = '5th column',
}

export type ContentfulHeaderMenuProp = {
  label: string;
  url: string;
  column: string;
  isPrimary: boolean;
  ordering: number;
};

export type HeaderDrawerProp = {
  isPrimary: boolean;
  column: number;
} & LinkProp;

export const applyContentfulLinksSetOrdering = (links: ContentfulHeaderMenuProp[]): ContentfulHeaderMenuProp[] =>
  links.sort((a: ContentfulHeaderMenuProp, b: ContentfulHeaderMenuProp) => {
    if (a.ordering < b.ordering) {
      return -1;
    }
    if (a.ordering > b.ordering) {
      return 1;
    }
    return 0;
  });

export const getMainBarLinksFromResponse = (links: ContentfulHeaderMenuProp[]): LinkProp[] =>
  links.reduce((acc: LinkProp[], entry: ContentfulHeaderMenuProp) => {
    // First charcter of Main, 1st, 2nd, 3rd or 4th => M, 1, 2, 3 or 4
    if (entry.column === HeaderColumns.MAIN_BAR && acc.length < 3) {
      acc.push({
        label: entry.label,
        href: entry.url,
      });
    }
    return acc;
  }, []);

export const getDrawerLinksFromResponse = (links: ContentfulHeaderMenuProp[]): HeaderDrawerProp[] =>
  links.reduce((acc: HeaderDrawerProp[], entry: ContentfulHeaderMenuProp) => {
    if (entry.column !== HeaderColumns.MAIN_BAR) {
      let index;
      switch (entry.column) {
        case HeaderColumns.FIRST_COLUMN:
          index = 0;
          break;
        case HeaderColumns.SECOND_COLUMN:
          index = 1;
          break;
        case HeaderColumns.THIRD_COLUMN:
          index = 2;
          break;
        case HeaderColumns.FOURTH_COLUMN:
          index = 3;
          break;
        case HeaderColumns.FIFTH_COLUMN:
          index = 4;
          break;
        default:
          index = 0;
      }

      acc.push({
        label: entry.label,
        href: entry.url,
        isPrimary: entry.isPrimary,
        column: index,
      });
    }
    return acc;
  }, []);

export const splitDrawerLinksIntoColumns = (data: HeaderDrawerProp[]): HeaderDrawerProp[][] => {
  const defaultColumns = [[], [], [], []]; // 4 columns
  return data.reduce(
    (acc: HeaderDrawerProp[][], entry: HeaderDrawerProp) => {
      // add additional columns if needed
      if (!acc[entry.column]) {
        acc[entry.column] = [];
      }

      // add entry to column
      acc[entry.column].push(entry);
      return acc;
    },
    defaultColumns // 1st, 2nd, 3rd and 4th column
  );
};
